// @ts-nocheck
import React, { Component } from 'react';
import { observer, inject } from "../../../stores/mobx-compat";
import moment from 'moment';
import _ from 'lodash';

import Card, { CardHead } from '../../ui/Card';
import Button from '../../ui/Button';
import Modal, { ModalActions } from '../../ui/Modal';
import { XCircleIcon, CheckCircleIcon, CreditCardIcon } from '../../ui/icons';
import CardInput from '../PaymentSetup/CardInput';

const Row = ({ label, children }) => (
  <div className="flex items-center justify-between gap-3" style={{ borderBottom: '1px dashed var(--mov-line)', paddingBottom: 8 }}>
    <dt className="text-mov-ink-mute mov-mono text-[11px] uppercase tracking-wider">{label}</dt>
    <dd className="m-0 text-right">{children}</dd>
  </div>
);

class AccountDetails extends Component {
  state = { open: false };

  formatMoney = (num) => {
    const numText = String(num);
    if (numText.length === 1) return 'Free';
    return `$${numText.slice(0, -2)}.${numText.slice(-2)} / month`;
  }

  render() {
    const {
      account: {
        sources: { data: payments },
        subscriptions,
      },
    } = this.props.store.accountStatus;
    const { loading } = this.props.store.payments;
    const subData = _.get(subscriptions, ['data', '0', 'items', 'data'], []);
    const planData = _.get(subData, ['0', 'plan']);
    const sub = subscriptions.data[0];
    const card = payments[0];

    return (
      <>
        <div
          className="grid gap-5 mb-5"
          style={{ gridTemplateColumns: this.props.store.ui.mobile ? '1fr' : '1fr 1fr' }}
        >
          <Card padded>
            <CardHead title="Subscription" />
            <dl className="m-0 grid gap-2.5 text-[13px]">
              <Row label="Plan"><b>{planData.metadata.name}</b></Row>
              <Row label="Cost">{this.formatMoney(planData.amount)}</Row>
              <Row label="Usage limit">{planData.metadata.limit}</Row>
              <Row label="Next billing">{moment(sub.current_period_end * 1000).format('MM/DD/YYYY')}</Row>
              {sub.cancel_at && (
                <Row label="Cancels on">{moment(sub.current_period_end * 1000).format('MM/DD/YYYY')}</Row>
              )}
            </dl>
            {!sub.cancel_at_period_end && (
              <div className="mt-3 flex justify-end">
                <Button
                  variant="default"
                  icon={XCircleIcon}
                  onClick={() => this.setState({ open: true })}
                >
                  Cancel subscription
                </Button>
              </div>
            )}
          </Card>

          <Card padded>
            <CardHead title="Payment method" />
            <dl className="m-0 grid gap-2.5 text-[13px]">
              <Row label="Card">
                <span className="mov-mono">**** **** **** {card.last4}</span>
                <span className="ml-2 text-mov-ink-mute">{card.brand}</span>
              </Row>
              <Row label="Expires">{card.exp_month}/{card.exp_year}</Row>
            </dl>
            <div className="mt-4">
              <div className="mov-mono text-[11px] uppercase tracking-wider text-mov-ink-mute mb-2">Change payment source</div>
              <CardInput />
            </div>
            <div className="mt-3 flex justify-end">
              <Button
                variant="primary"
                icon={CheckCircleIcon}
                loading={loading}
                disabled={loading}
                onClick={() => this.props.store.payments.updateStripePayment()}
              >
                Update payment
              </Button>
            </div>
          </Card>
        </div>

        <Modal
          open={this.state.open}
          onClose={() => this.setState({ open: false })}
          size="sm"
          title="Cancel subscription?"
          icon={CreditCardIcon}
          actions={(
            <ModalActions
              onCancel={() => this.setState({ open: false })}
              onConfirm={async () => {
                await this.props.store.accountStatus.cancelSubscription();
                this.setState({ open: false });
              }}
              confirmLabel="Yes, cancel"
              confirmVariant="danger"
            />
          )}
        >
          <p className="m-0 text-[13px] text-mov-ink-soft">
            You&apos;ll keep access until <b className="text-mov-ink">{moment(sub.current_period_end * 1000).format('MM/DD/YYYY')}</b>,
            then your subscription will end.
          </p>
        </Modal>
      </>
    );
  }
}

export default inject('store')(observer(AccountDetails));
